<li class="list-group-item">
    <div class="w-100 d-flex flex-row justify-content-between">
        <span class="name fs-5">freak532486</span>
        <span class="role">Owner</span>
    </div>
</li>